(function () {
  'use strict';

  /* ——— Gallery ——— */
  document.querySelectorAll('[data-fp-gal]').forEach(function (gal) {
    var track = gal.querySelector('[data-fp-gal-track]');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('.fp-gal__slide'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-fp-gal-thumb]'));
    var dots = Array.prototype.slice.call(gal.querySelectorAll('.fp-gal__dots i'));
    var dialog = gal.querySelector('[data-fp-gal-dialog]');
    var full = gal.querySelector('[data-fp-gal-full]');
    var stagePrev = gal.querySelector('.fp-gal__stage [data-fp-gal-prev]');
    var stageNext = gal.querySelector('.fp-gal__stage [data-fp-gal-next]');
    var current = 0;
    if (!track || !slides.length) return;

    function mark(index) {
      current = index;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-on', i === index);
        if (i === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === index); });
      if (stagePrev) stagePrev.disabled = index === 0;
      if (stageNext) stageNext.disabled = index === slides.length - 1;
      if (dialog && dialog.open) showFull(index);
    }

    function go(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      mark(index);
    }

    function showFull(index) {
      var img = slides[index].querySelector('img');
      full.src = img.getAttribute('data-full') || img.currentSrc || img.src;
      full.alt = img.alt;
    }

    var scrollTimer = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (index !== current) mark(index);
      }, 60);
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-fp-gal-thumb'), 10)); });
    });
    gal.querySelectorAll('[data-fp-gal-prev]').forEach(function (b) {
      b.addEventListener('click', function () { go(current - 1); });
    });
    gal.querySelectorAll('[data-fp-gal-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(current + 1); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });

    function openFull() {
      if (!dialog || !dialog.showModal) return;
      showFull(current);
      dialog.showModal();
    }
    gal.querySelector('[data-fp-gal-open]').addEventListener('click', openFull);
    slides.forEach(function (s) { s.querySelector('img').addEventListener('click', openFull); });

    if (dialog) {
      dialog.querySelector('[data-fp-gal-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') go(current + 1);
        if (e.key === 'ArrowLeft') go(current - 1);
      });
    }

    mark(0);
  });

  /* ——— App card: iPhone and iPad only ——— */
  var ua = navigator.userAgent;
  var isIOS = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  if (isIOS) {
    document.querySelectorAll('[data-fp-ios]').forEach(function (el) { el.hidden = false; });
  }

  /* ——— Ship-by date: up to 3 business days from today ——— */
  var shipBy = document.querySelector('[data-fp-shipby]');
  if (shipBy) {
    var date = new Date();
    var added = 0;
    while (added < 3) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
    }
    var label = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    shipBy.textContent = 'Order today, ships by ' + label;
  }

  var order = document.getElementById('fp-pdp-order');
  var box = document.getElementById('uploadBox');
  if (order && box) {
    var countEl = order.querySelector('[data-fp-order-count]');
    var jump = document.querySelector('.fp-pdp-head__jump');
    var target = document.getElementById('fp-44wb-cta-target') || document.getElementById('fp-magnets-cta-target');
    var done = null;
    if (target) {
      done = document.createElement('div');
      done.className = 'fp-pdp-order__loaded fp-pdp-done';
      done.hidden = true;
      done.innerHTML = '<span class="fp-pdp-order__check" aria-hidden="true">✓</span>' +
        '<div><p class="fp-pdp-order__count"><b data-fp-order-count></b> ready to print</p>' +
        '<p class="fp-pdp-order__tip">Look good? Add them to your cart, or add more photos.</p></div>';
      target.parentNode.insertBefore(done, target);
    }
    var root = document.documentElement;
    root.classList.add('fp-cart-gate');
    var sync = function () {
      var n = box.querySelectorAll('.box').length;
      var label = n + (n === 1 ? ' photo' : ' photos');
      order.classList.toggle('is-loaded', n > 0);
      root.classList.toggle('fp-has-photos', n > 0);
      if (countEl) countEl.textContent = label;
      if (done) {
        done.hidden = n === 0;
        done.querySelector('[data-fp-order-count]').textContent = label;
      }
      if (jump) jump.textContent = n > 0 ? 'Review your ' + n + (n === 1 ? ' photo' : ' photos') + ' ↓' : 'Choose photos ↓';
    };
    new MutationObserver(sync).observe(box, { childList: true, subtree: true });
    sync();
  }
})();
